import './skils.scss';
const MySkils = () => {
    return (
        <div className="skils-container">
            <h2 className="center">My Overall Skills</h2>
            <h5 className="center"> (But still Improving and Learning new) </h5>

            <p>ReactJs</p>
            <div class="skils-wrapper">
                <div class="skills top">90%</div>
            </div>


            <p>JavaScript</p>
            <div class="skils-wrapper">
                <div class="skills best">80%</div>
            </div>


            <p>HTML5</p>
            <div class="skils-wrapper">
                <div class="skills top">90%</div>
            </div>

            <p>CSS3</p>
            <div class="skils-wrapper">
                <div class="skills top">90%</div>
            </div>

            <p>Sass, Material Ui, Bootstrap</p>
            <div class="skils-wrapper">
                <div class="skills best">80%</div>
            </div>

            <p>Angular6+</p>
            <div class="skils-wrapper">
                <div class="skills good">70%</div>
            </div>

            <p>Github, Jira</p>
            <div class="skils-wrapper">
                <div class="skills top">90%</div>
            </div>

            <p>Responsive Web Design</p>
            <div class="skils-wrapper">
                <div class="skills top">90%</div>
            </div>

            <p>NodeJs and ExpressJs</p>
            <div class="skils-wrapper">
                <div class="skills average">60%</div>
            </div>

            <p>Windows / MS Office, Adobe Photoshop</p>
            <div class="skils-wrapper">
                <div class="skills good">70%</div>
            </div>
            
            
            


        </div>
    )
}

export default MySkils;